{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Виберіть елемент",
  "tableResizer": "Засіб змінення розміру",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
